import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity, Link as LinkClass } from "../../../api/classes";
import {
  Avatar,
  Typography,
  IconButton,
  Tooltip,
  Card
} from "@material-ui/core";
import { Link } from "react-router-dom";
import TeyitLinkIcon from "@material-ui/icons/Bookmark";
import WebIcon from "@material-ui/icons/Link";
import * as moment from "moment";
import MoreSettings from "../../../components/more";
import ApproveDialog from "src/components/dialogs/approveDialog";
import { FacebookProvider, EmbeddedPost, LoginButton } from "react-facebook";
import TwitterTweetEmbed from "../../../components/TwitterEmbed";
import { FacebookVirality } from "src/pages/tools/facebookVirality";

interface Props {
  link: LinkClass;
  style?: React.CSSProperties;
  onDelete?: (link: LinkClass) => void;
}
class CaseLink extends React.Component<Props> {
  state = {
    deleteOpen: false
  };
  deleteLink = () => {
    this.props.onDelete(this.props.link);
  };
  render() {
    const { link, style } = this.props;
    return (
      <Card style={{ marginBottom: 16, marginTop: 16 }}>
        <div
          style={{
            ...style,
            display: "flex",
            flexDirection: "row",
            padding: 16,
            alignItems: "center"
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography
              style={{ marginLeft: 8, wordBreak: "break-all" }}
              variant="body2"
            >
              {link.meta_title && link.meta_title.length > 0
                ? link.meta_title
                : link.link}
            </Typography>
            <a
              target="_blank"
              href={link.link}
              style={{ textDecoration: "none" }}
            >
              <Typography
                style={{
                  marginLeft: 8,
                  fontSize: 12,
                  lineHeight: "12px",
                  wordBreak: "break-all"
                }}
                variant="caption"
              >
                {link.link}
              </Typography>
            </a>
            <Typography
              style={{ marginLeft: 8, fontSize: 12 }}
              variant="caption"
            >
              {moment(link.created_at).format("LLL")}
            </Typography>
          </div>
          <a target="_blank" href={link.teyitlink_slug}>
            <Tooltip title="Archived Link">
              <IconButton>
                <TeyitLinkIcon />
              </IconButton>
            </Tooltip>
          </a>
          <a target="_blank" href={link.link}>
            <Tooltip title="Original Website">
              <IconButton>
                <WebIcon />
              </IconButton>
            </Tooltip>
          </a>

          {this.props.onDelete && (
            <>
              <MoreSettings
                options={[
                  {
                    label: "Delete",
                    onClick: () => {
                      this.setState({ deleteOpen: true });
                    }
                  }
                ]}
              />
              <ApproveDialog
                open={this.state.deleteOpen}
                title="Delete Link"
                description={
                  <>
                    Do you want to delete
                    <b>{" " + this.props.link.link + " "}</b>
                    from this case?
                  </>
                }
                onApprove={this.deleteLink}
              />
            </>
          )}
        </div>
        {this.renderData()}
      </Card>
    );
  }
  renderData() {
    if (this.props.link.link.indexOf("www.facebook.com") > -1) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 12
          }}
        >
          <FacebookProvider appId="213471075795721">
            <EmbeddedPost href={this.props.link.link} width="500" />
          </FacebookProvider>
        </div>
      );
    } else if (this.props.link.link.indexOf("twitter.com") > -1) {
      return this.renderTwitter();
    } else {
      return <FacebookVirality url={this.props.link.link} />;
    }
  }
  renderTwitter() {
    const arr = this.props.link.link.split("/");
    let tweetId = arr[arr.length - 1];
    const i = tweetId.indexOf("?");
    if (i > -1) {
      tweetId = tweetId.substring(0, i);
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: 12
        }}
      >
        <TwitterTweetEmbed tweetId={tweetId} />
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseLink);



// WEBPACK FOOTER //
// ./src/pages/cases/components/link.tsx